/*!
 * JavaScript for Christmas gift tag
 * Give as you Live Ltd
 */

// Import Christmas
const GiftTag = require('Scripts/gayl/christmas-gift-tag');